import React from 'react';
import update from 'immutability-helper';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button, Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { getNavInfos } from 'helpers/nav';
import { mainMenuVersionOptionFromEntity } from 'components/forms/autocomplete/MainMenuVersion';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import WhiteLabelMainMenuTableRow from 'components/layout/whiteLabel/WhiteLabelMainMenuTableRow';
import WhiteLabelMainMenuElementData from 'components/layout/whiteLabel/WhiteLabelMainMenuElementData';
import MainMenu from 'components/layout/mainMenus/MainMenu';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormSwitchery from 'components/forms/FormSwitchery';

class WhiteLabelMainMenu extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      shownElementIndex: null,
      shownSecondaryElementIndex: null,
    };
  }

  /* Main menu methods: */
  addElement = () => {
    const { entity, changeEntity } = this.props;
    const newElement = entity.createValue('elements', ['menu']);
    const newValue = entity
      .getMenu()
      .getElements()
      .slice();
    newValue.push(newElement);
    const newEntity = { ...entity.updateValue('elements', newValue, ['menu']) };

    this.setState({ shownElementIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleElementClick = index => {
    this.setState(prevState => ({ shownElementIndex: index === prevState.shownElementIndex ? null : index }));
  };

  handleElementRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeElementEntry(index);
  };

  removeElementEntry = index => {
    if (this.state.shownElementIndex === index) {
      this.setState({ shownElementIndex: null }, () => this.removeElementEntry(index));
    } else {
      const { entity, changeEntity } = this.props;
      const newValue = entity
        .getMenu()
        .getElements()
        .slice();
      newValue.splice(index, 1);
      const newEntity = { ...entity.updateValue('elements', newValue, ['menu']) };

      changeEntity(newEntity);
    }
  };

  // when dragging, move the elements
  moveElements = (fromIndex, toIndex) => {
    const { entity, changeEntity } = this.props;

    const myData = {
      elements: entity
        .getMenu()
        .getElements()
        .slice(),
    };
    const element = myData.elements[fromIndex];
    const newData = update(myData, {
      elements: {
        $splice: [[fromIndex, 1], [toIndex, 0, element]],
      },
    });

    const newEntity = { ...entity.updateValue('elements', newData.elements, ['menu']) };

    changeEntity(newEntity);
  };

  /* Secondary menu elements: */
  addSecondaryElement = () => {
    const { entity, changeEntity } = this.props;
    const newElement = entity.createValue('secondaryElements', ['menu']);
    const newValue = entity
      .getMenu()
      .getSecondaryElements()
      .slice();
    newValue.push(newElement);
    const newEntity = { ...entity.updateValue('secondaryElements', newValue, ['menu']) };

    this.setState({ shownSecondaryElementIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleSecondaryElementClick = index => {
    this.setState(prevState => ({
      shownSecondaryElementIndex: index === prevState.shownSecondaryElementIndex ? null : index,
    }));
  };

  handleSecondaryElementRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeSecondaryElementEntry(index);
  };

  removeSecondaryElementEntry = index => {
    if (this.state.shownSecondaryElementIndex === index) {
      this.setState({ shownSecondaryElementIndex: null }, () => this.removeSecondaryElementEntry(index));
    } else {
      const { entity, changeEntity } = this.props;
      const newValue = entity
        .getMenu()
        .getSecondaryElements()
        .slice();
      newValue.splice(index, 1);
      const newEntity = { ...entity.updateValue('secondaryElements', newValue, ['menu']) };

      changeEntity(newEntity);
    }
  };

  // when dragging, move the elements
  moveSecondaryElements = (fromIndex, toIndex) => {
    const { entity, changeEntity } = this.props;

    const myData = {
      elements: entity
        .getMenu()
        .getSecondaryElements()
        .slice(),
    };
    const element = myData.elements[fromIndex];
    const newData = update(myData, {
      elements: {
        $splice: [[fromIndex, 1], [toIndex, 0, element]],
      },
    });

    const newEntity = { ...entity.updateValue('secondaryElements', newData.elements, ['menu']) };

    changeEntity(newEntity);
  };

  render() {
    const {
      intl: { messages },
      intl,
      appIntl,
      entity,
      entityLoaded,
      changeEntity,
      disabled,
      layout,
      projectConfig,
      user,
    } = this.props;
    const { shownElementIndex, shownSecondaryElementIndex } = this.state;

    const columns = [messages.name, messages.actions];
    let elementsTBody;
    let secondaryElementsTBody;
    if (entityLoaded) {
      if (entity.getMenu().getElements() && entity.getMenu().getElements().length) {
        elementsTBody = entity
          .getMenu()
          .getElements()
          .map((element, i) => {
            return (
              <WhiteLabelMainMenuTableRow
                key={i}
                messages={messages}
                data={element}
                shownIndex={shownElementIndex}
                index={i}
                onClick={() => this.handleElementClick(i)}
                name={getNameInCurrentLanguage(element.getName(), appIntl)}
                handleRemove={e => this.handleElementRemoveClick(e, i)}
                hideDetails={() => this.setState({ shownElementIndex: null })}
                moveElements={this.moveElements}
                user={user}
                disabled={disabled}
              />
            );
          });
      }

      if (entity.getMenu().getSecondaryElements() && entity.getMenu().getSecondaryElements().length) {
        secondaryElementsTBody = entity
          .getMenu()
          .getSecondaryElements()
          .map((element, i) => {
            return (
              <WhiteLabelMainMenuTableRow
                key={i}
                messages={messages}
                data={element}
                shownIndex={shownSecondaryElementIndex}
                index={i}
                onClick={() => this.handleSecondaryElementClick(i)}
                name={getNameInCurrentLanguage(element.getName(), appIntl)}
                handleRemove={e => this.handleSecondaryElementRemoveClick(e, i)}
                hideDetails={() => this.setState({ shownElementIndex: null })}
                moveElements={this.moveSecondaryElements}
                user={user}
                disabled={disabled}
              />
            );
          });
      }
    }

    if (shownElementIndex !== null) {
      const data = entity.getMenu().getElements()[shownElementIndex];

      // user wants to see a element form form
      elementsTBody.splice(
        shownElementIndex + 1,
        0,
        <tr key={'details-showing-' + shownElementIndex} className="row-details">
          <td colSpan={columns.length}>
            <WhiteLabelMainMenuElementData
              intl={intl}
              appIntl={appIntl}
              data={data}
              index={shownElementIndex}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              disabled={disabled}
            />
          </td>
        </tr>
      );
    }

    if (shownSecondaryElementIndex !== null) {
      const data = entity.getMenu().getSecondaryElements()[shownSecondaryElementIndex];

      // user wants to see a element form form
      secondaryElementsTBody.splice(
        shownSecondaryElementIndex + 1,
        0,
        <tr key={'details-showing-' + shownElementIndex} className="row-details">
          <td colSpan={columns.length}>
            <WhiteLabelMainMenuElementData
              intl={intl}
              appIntl={appIntl}
              menuList="secondaryElements"
              data={data}
              index={shownSecondaryElementIndex}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              disabled={disabled}
            />
          </td>
        </tr>
      );
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div className="padding-20 sm-padding-10">
            <p>{messages.primary_menu_elements}</p>
            <Row>
              <Col xs={12}>
                <Table responsive hover className="table-detailed">
                  <thead>
                    <tr>
                      {columns.map((column, i) => {
                        return (
                          <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                            {column}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="tablerows"
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={1}
                    component="tbody"
                  >
                    {elementsTBody}
                  </ReactCSSTransitionGroup>
                </Table>

                <div className="m-t-10">
                  <Button onClick={this.addElement} disabled={disabled}>
                    {messages.add_menu_element}
                  </Button>
                </div>
              </Col>
            </Row>

            <hr />

            {entity
              .getMenu()
              .getVersion()
              .getHasSecondaryElements() && (
              <>
                <p>{messages.secondary_menu_elements}</p>
                <Row>
                  <Col xs={12}>
                    <Table responsive hover className="table-detailed">
                      <thead>
                        <tr>
                          {columns.map((column, i) => {
                            return (
                              <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                                {column}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <ReactCSSTransitionGroup
                        transitionName="tablerows"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={1}
                        component="tbody"
                      >
                        {secondaryElementsTBody}
                      </ReactCSSTransitionGroup>
                    </Table>

                    <div className="m-t-10">
                      <Button onClick={this.addSecondaryElement} disabled={disabled}>
                        {messages.add_secondary_menu_element}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <hr />
              </>
            )}

            <p>{messages.main_menu_version}</p>
            <Row>
              <Col xs={12}>
                <p>Preview:</p>
              </Col>
              <Col xs={12}>
                <div className="b-a b-grey">
                  <MainMenu
                    {...getNavInfos(appIntl, layout, projectConfig, user)}
                    preview
                    menuVersion={entity
                      .getMenu()
                      .getVersion()
                      .getId()}
                  />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <p className="m-t-15 form-group-title">{messages.settings}</p>
                <div className="form-group-attached">
                  <FormAutocomplete
                    name="version"
                    autocompleteType="mainMenuVersion"
                    label={messages.main_menu_version}
                    returnValueObject
                    onChange={(fieldName, value) => this.updateEntity(fieldName, value, ['menu'])}
                    value={
                      (!!entity
                        .getMenu()
                        .getVersion()
                        .getId() &&
                        mainMenuVersionOptionFromEntity(entity.getMenu().getVersion())) || {
                        value: 'default',
                        label: 'Standard',
                      }
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
WhiteLabelMainMenu.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
    user: state.login.user,
    projectConfig: state.data.projectConfig,
  };
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelMainMenu));
